import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";
import { useT } from "@/lib/i18n";

export default function BillingSuccess() {
  const t = useT();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [tx, setTx] = useState(null);
  const [attempts, setAttempts] = useState(0);
  const pollRef = useRef(null);

  useEffect(() => {
    if (!sessionId) return;
    const poll = async () => {
      try {
        const { data } = await api.get(`/billing/checkout/status/${sessionId}`);
        setTx(data);
        setAttempts((a) => a + 1);
        if (data.payment_status === "paid" || data.status === "expired") clearInterval(pollRef.current);
      } catch {}
    };
    poll();
    pollRef.current = setInterval(poll, 2000);
    return () => clearInterval(pollRef.current);
  }, [sessionId]);

  useEffect(() => {
    if (attempts > 8) clearInterval(pollRef.current);
  }, [attempts]);

  return (
    <div className="p-12 max-w-2xl mx-auto text-center">
      {!tx || tx.payment_status !== "paid" ? (
        <>
          <Loader2 className="w-8 h-8 text-primary animate-spin mx-auto mb-6" />
          <h1 className="font-display font-black text-3xl tracking-tighter">{t("billing.confirming")}</h1>
          <p className="text-white/60 mt-3 text-sm">{t("billing.confirmingDesc")}</p>
        </>
      ) : (
        <>
          <CheckCircle2 className="w-12 h-12 text-emerald-400 mx-auto mb-6" />
          <h1 className="font-display font-black text-3xl tracking-tighter">{t("billing.confirmed")}</h1>
          <p className="text-white/60 mt-3">{t("billing.confirmedDesc")} <span className="text-primary font-mono">{tx.plan_id.toUpperCase()}</span>.</p>
          <Link to="/app" className="btn-primary mt-8 inline-flex" data-testid="billing-success-cta">{t("billing.goDash")}</Link>
        </>
      )}
    </div>
  );
}
